import { useApi } from "../../hooks/useApi";
import { web } from "../../lib/api";
import { autoBenchmark, bestRank, benchmarkPhrase } from "../../lib/benchmarks";
import { METRICS } from "./CombinePanel";

/** Profile header label for the player's strongest combine result vs. their level's benchmark, e.g. "Top 25% standing vert for Varsity guards". */
export const BenchmarkRank = ({ player, bests, className = "" }) => {
  const list = useApi("/benchmarks", web);
  const b = autoBenchmark(Array.isArray(list.data) ? list.data : [], player);
  const r = bestRank(b, bests);
  if (!r) return null;
  const metric = (METRICS.find(([k]) => k === r.key)?.[1] ?? r.key).toLowerCase();
  return (
    <div className={className}>
    <span data-testid="benchmark-rank-badge" className="inline-flex items-center gap-2 rounded-full border border-[#39FF14]/40 bg-[#39FF14]/10 px-3 py-1 font-mono-gd text-xs uppercase tracking-wider text-[#39FF14]">
      {r.label} {metric} <span className="text-slate-300">for {benchmarkPhrase(b)}</span>
    </span>
    </div>
  );
};
